import React from "react"
import "./card css/m-achievement.css"

export default function Machievement(){
    return(
        <div className="m-achievement-container">
            <h1 className="m-achievement-title">Main Achievements</h1>
            <div>
                <p className="coming-soon">Coming Soon</p>
            </div>
        </div>
    )
}